/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */

import { cssMap as cssMapCompiled, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors */
const compiledStyles = cssMapCompiled({
	taskTrigger: {
		backgroundColor: token('color.background.neutral.bold'), // '#0f1012',
		borderRadius: '6px',
		'& button': {
			backgroundColor: 'transparent',
			color: token('color.text.inverse'),
		},
		'& button:hover': {
			backgroundColor: token('color.background.neutral.bold.hovered'),
			borderRadius: '6px',
		},
		'& button span': {
			color: token('color.text.inverse'),
		},
		'& button span[role="img"]': {
			color: token('color.text.inverse'),
		},
	},
});
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors */

/**
 * Wrapper component that adds a dark background and mouse-tracking
 * glow/spotlight effect to the Task mode menu item.
 * The task item is always dark — selected uses a deeper black, unselected
 * uses a dark grey. A radial glow follows the cursor.
 */
type TaskModeTriggerWrapperProps = {
	children: React.ReactNode;
};

/**
 * Wrapper that applies a dark background and white text/icon styling
 * to the trigger button when Task mode is selected.
 */
export const TaskModeTriggerWrapper = ({ children }: TaskModeTriggerWrapperProps): JSX.Element => (
	<div css={compiledStyles.taskTrigger}>{children}</div>
);
